<template>
  <div class="outer-section Articles">
    <RwvArticleList></RwvArticleList>
  </div>
</template>

<script>
import RwvArticleList from '@/components/Articles/ArticleList.vue'

export default {
  title: "Artikel | So wird's gemacht",
  name: 'articles',
  components: {
    RwvArticleList
  }
}
</script>

<style lang="scss">
</style>
